import { useAtomValue } from 'jotai'

import { socialMediaPrimaryColorAtom } from './SocialMediaScreenState'

export const SocialMediaHeader = () => {
	const primaryColor = useAtomValue(socialMediaPrimaryColorAtom)

	return (
		<div
			className="flex flex-col items-center px-5 py-3 transition-colors"
			style={{
				backgroundColor: primaryColor,
			}}
		></div>
	)
}
